import request from "@/utils/request";
// 验证是否参与活动
export function verifActivity(params) {
  return request({
    url: "/h5/Member/verifActivity",
    method: "post",
    params,
  });
}
// 参与活动
export function involvedActivity(params) {
  return request({
    url: "/h5/Member/involvedActivity",
    method: "post",
    params,
  });
}
// 参与活动埋点
export function memberActivityPvStat(params) {
  return request({
    url: "/h5/PageRecord/memberActivityPvStat",
    method: "post",
    params,
  });
}
